import { render, staticRenderFns } from "./DashboardCarga.vue?vue&type=template&id=84dfbee8&scoped=true"
import script from "./DashboardCarga.vue?vue&type=script&lang=js"
export * from "./DashboardCarga.vue?vue&type=script&lang=js"
import style0 from "./DashboardCarga.vue?vue&type=style&index=0&id=84dfbee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dfbee8",
  null
  
)

export default component.exports